import Logger from '../utils/Logger';

// feature names
export const FEATURE_FIMLAB = 'fimlab';
export const FEATURE_APPOINTMENT = 'appointment';
export const FEATURE_IMAGING = 'imaging';
export const FEATURE_BIOBANK = 'biobank';
export const FEATURE_CONTACT = 'contact';
export const FEATURE_USERINFOREQUEST = 'userinforequest';
export const FEATURE_USERINFOREQUEST_DISABLED = 'userinforequestdisabled';

let _frontendProperties = {};
let _versionInfo = {};
let _features = [];

const configure = ({ frontendProperties, versionInfo, features }) => {
  _frontendProperties = frontendProperties;
  _versionInfo = versionInfo;
  _features = features;
};

const getFrontendProperties = () => {
  return _frontendProperties;
};

const getVersionInfo = () => {
  return _versionInfo;
};

const getFeatures = () => {
  return _features;
};

const isFeatureOn = (featureName) => {
  return _features.includes(featureName);
};

const configureLogging = (opts) => {
  // set up logging like this
  if (process.env.NODE_ENV === 'production') {
    Logger().setLevel(opts.prod.logging.level);
    opts.prod.logging.moduleIdLevels &&
      opts.prod.logging.moduleIdLevels.forEach(function (moduleIdLevel) {
        Logger().setLevel(moduleIdLevel.level, moduleIdLevel.moduleId);
      });
  } else {
    Logger().setLevel(opts.dev.logging.level);
    opts.dev.logging.moduleIdLevels &&
      opts.dev.logging.moduleIdLevels.forEach(function (moduleIdLevel) {
        Logger().setLevel(moduleIdLevel.level, moduleIdLevel.moduleId);
      });
  }
};

export {
  configure,
  configureLogging,
  getFrontendProperties,
  getVersionInfo,
  getFeatures,
  isFeatureOn,
};
